import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4e4bd30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ssg-navbar" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-content" }, " 온라인 참여 신청 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-content" }, " 간편수거 신청 ", -1))

import IconArrow from '../images/navbar/icon-arrow.png';
import IconArrowPC from '../images/navbar/icon-arrow-pc.png';
import CampaignParticipate from './participate.vue';
import CampaignApply from './apply.vue';
import { IProgram } from '@/types/program';

interface Props {
  program: IProgram;
}
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

;


const items = [
  {
    label: '온라인 일정',
    target: '#page-2',
  },
  {
    label: '오프라인 일정',
    target: '#page-5',
  },
];

function scrollToTarget(target: string) {
  document.querySelector(target)?.scrollIntoView();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
        return _createElementVNode("li", {
          key: item.label
        }, [
          _createElementVNode("span", {
            class: "item-content",
            onClick: ($event: any) => (scrollToTarget(item.target))
          }, [
            _createTextVNode(_toDisplayString(item.label), 1),
            _createElementVNode("img", {
              class: "d-block d-md-none icon",
              src: _unref(IconArrow)
            }, null, 8, _hoisted_3),
            _createElementVNode("img", {
              class: "d-none d-md-block icon",
              src: _unref(IconArrowPC)
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_2)
        ])
      }), 64)),
      _createElementVNode("li", null, [
        _createVNode(CampaignParticipate, { program: __props.program }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["program"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(CampaignApply, { program: __props.program }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["program"])
      ])
    ])
  ]))
}
}

})